
import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Opportunity } from "@/types/database-extensions";

interface OpportunityFormProps {
  currentOpportunity: Partial<Opportunity>;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  isSubmitting: boolean;
}

const OpportunityForm: React.FC<OpportunityFormProps> = ({
  currentOpportunity,
  handleInputChange,
  isSubmitting,
}) => {
  return (
    <div className="space-y-4 pt-4">
      <div className="space-y-2">
        <label htmlFor="title" className="text-sm font-medium">
          Title *
        </label>
        <Input
          id="title"
          name="title"
          value={currentOpportunity.title}
          onChange={handleInputChange}
          disabled={isSubmitting}
          required
        />
      </div>

      <div className="space-y-2">
        <label htmlFor="organization" className="text-sm font-medium">
          Organization *
        </label>
        <Input
          id="organization"
          name="organization"
          value={currentOpportunity.organization}
          onChange={handleInputChange}
          disabled={isSubmitting}
          required
        />
      </div>

      <div className="space-y-2">
        <label htmlFor="description" className="text-sm font-medium">
          Description *
        </label>
        <Textarea
          id="description"
          name="description"
          rows={4}
          value={currentOpportunity.description}
          onChange={handleInputChange}
          disabled={isSubmitting}
          required
        />
      </div>

      <div className="space-y-2">
        <label htmlFor="location" className="text-sm font-medium">
          Location
        </label>
        <Input
          id="location"
          name="location"
          value={currentOpportunity.location}
          onChange={handleInputChange}
          disabled={isSubmitting}
        />
      </div>

      <div className="space-y-2">
        <label htmlFor="type" className="text-sm font-medium">
          Type
        </label>
        <Input
          id="type"
          name="type"
          value={currentOpportunity.type}
          onChange={handleInputChange}
          disabled={isSubmitting}
        />
      </div>

      <div className="space-y-2">
        <label htmlFor="deadline" className="text-sm font-medium">
          Deadline
        </label>
        <Input
          id="deadline"
          name="deadline"
          type="date"
          value={currentOpportunity.deadline || ""}
          onChange={handleInputChange}
          disabled={isSubmitting}
        />
      </div>

      <div className="space-y-2">
        <label htmlFor="application_url" className="text-sm font-medium">
          Application URL
        </label>
        <Input
          id="application_url"
          name="application_url"
          value={currentOpportunity.application_url || ""}
          onChange={handleInputChange}
          disabled={isSubmitting}
        />
      </div>
    </div>
  );
};

export default OpportunityForm;
